<template>
  <div class="layout-options-setting-dialog">
    <el-collapse v-model="activeNames">
      <dataGridSize :options="options" :ids="ids" />
      <el-collapse-item title="排列" name="1" v-if="!disableSetColAndRow && !isLoginLayout && !isSearchComponent">
        <template slot="title">
          排列
          <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick(1)"></i>
        </template>
        <div class="setting-item clearFloat">
          <div class="content">
            <div class="content-item mb16">
              <layoutSetting :row="options.row" :col="options.col" @changeRowAndCol="changeRowAndColHandle"/>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="间距" name="2">
        <div class="setting-item" v-if="checkShowTabs('间距')">
          <div class="content">
            <div class="content-item mt8">
              <slider-and-input
                class=""
                inputWidth="small"
                inputHeight="small"
                :value.sync="columnGap"
                title="横向间距"
                :sliderMax="100"
                suffix="px"
              />
            </div>
          </div>
          <div class="content-item mt8">
            <slider-and-input
              class=""
              inputWidth="small"
              inputHeight="small"
              :value.sync="rowGap"
              title="纵向间距"
              :sliderMax="100"
              suffix="px"
            />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="背景" name="3">
        <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" />
      </el-collapse-item>
      <el-collapse-item title="边框" name="4">
        <div>
          <div class="content-item verticallyCenter mb8">
            <el-checkbox v-model="showBorder">显示边框</el-checkbox>
          </div>
          <cx-border
            v-if="showBorder"
            :borderWidth.sync="borderWidth"
            :borderStyle.sync="borderStyle"
            :borderColor.sync="borderColor"
            :borderIsThemeColor.sync="borderIsThemeColor"
          />
        </div>
        <div class="content-item mt12">
          <border-radius
            :borderTypeFlag.sync="borderTypeFlag"
            :borderRadius.sync="borderRadius"
            :borderTopLeftRadius.sync="borderTopLeftRadius"
            :borderTopRightRadius.sync="borderTopRightRadius"
            :borderBottomRightRadius.sync="borderBottomRightRadius"
            :borderBottomLeftRadius.sync="borderBottomLeftRadius"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item title="边距" name="5">
        <div class="setting-item">
          <div class="content">
            <div class="content-item">
              <cx-padding
                v-if="checkShowTabs('边距')"
                :paddingTypeFlag.sync="paddingTypeFlag"
                :padding.sync="padding"
                :paddingTop.sync="paddingTop"
                :paddingRight.sync="paddingRight"
                :paddingBottom.sync="paddingBottom"
                :paddingLeft.sync="paddingLeft"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="更多" name="6">
        <div class="setting-item" v-if="checkShowTabs('外观')">
          <div class="content">
            <slider-and-input
              class=""
              inputWidth="small"
              inputHeight="small"
              :value.sync="opacity"
              title="透明度"
              :sliderMax="100"
              suffix="%"
            />
            <div class="content-item mt8">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
            <div class="content-item mt16">
              <public-style :options="options" :ids="ids"></public-style>
            </div>
            <div class="content-item verticallyCenter mt16">
              <span class="mr16">溢出</span>
              <text-setting-overflow :overFlowType.sync="overFlowType" style="flex: 1"></text-setting-overflow>
          </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item v-show="$store.state.states.showPluginSetting" title="插件" name="6">
        <div class="setting-item">
          <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
        </div>
      </el-collapse-item>
    </el-collapse>
    <asyncPluginSettingSubmit
      :pluginName="options.pluginName"
      componentName="layoutComponent"
      :options="options"
      type="Setting"
      :rect_id="rect_id"
      :container_id="container_id"
    />
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        {{ explainTips }}<span>{{ explainTitle }}</span>
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dataGridSize from "./dataGridSize.vue"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import layoutSetting from "./layout-setting.vue"
import TextSettingOverflow from "modules/components/textSettingOverflow"
import { withMethodsHistoryCombine } from "utils/revork"
import publicStyle from "publicSetting/publicStyle.vue"
export default withMethodsHistoryCombine({
  components: {
    dataGridSize,
    elementPluginSetting,
    layoutSetting,
    TextSettingOverflow,
    publicStyle
  },
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2"],
      shapeChecked: true,
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("../../../assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("../../../assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("../../../assets/images/dotted-1.png")
        }
      ],
      displayPositionList: [
        {
          title: "上",
          label: "top"
        },
        {
          title: "下",
          label: "bottom"
        },
        {
          title: "左",
          label: "left"
        },
        {
          title: "右",
          label: "right"
        }
      ],
      displayPositionClassList: [
        {
          class: "signal_tb",
          label: "top"
        },
        {
          class: "signal_bt",
          label: "bottom"
        },
        {
          class: "signal_lr",
          label: "left"
        },
        {
          class: "signal_rl",
          label: "right"
        }
      ],
      top_status: true,
      contextPath: "",
      before: null,
      explainDialog: false,
      explainTips: "",
      explainTitle: "",
      explainImgSrc: require("../../../assets/images/tipsVideoImg/cropping-img.png"),
      explainVideoSrc: "",
      translate: 0
    }
  },
  watch: {
    "options.reload": {
      deep: true,
      handler(n, o) {
        if (n) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.$changeOptionsEV(false, "reload", false)
            }, 100)
          })
        }
      }
    }
  },
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
    this.initDisplaySetting()
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    opacity: {
      get() {
        return this.options.opacity
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    rowGap: {
      get() {
        return this.options.rowGap
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rowGap", false)
      }
    },
    columnGap: {
      get() {
        return this.options.columnGap
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "columnGap", false)
      }
    },
    isDraggable() {
      if (this.options && !this.options.hasOwnProperty("draggable")) {
        return true
      }
      return this.options.draggable
    },
    showLayoutSetting() {
      if (this.options.hasOwnProperty("showLayoutSetting") === false) return true
      return this.options.showLayoutSetting
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    displayPositionDataModel() {
      const titleOptions = this.options.titleOptions
      if (!titleOptions) {
        return
      }
      // 先给一个默认值
      let arr = [
        {
          type: "classification",
          position: "top",
          directionIndex: 0,
          elementInLayoutId: 3
        },
        {
          type: "pagination",
          position: "bottom",
          directionIndex: 1,
          elementInLayoutId: 0
        },
        {
          type: "more",
          position: "top",
          directionIndex: 0,
          elementInLayoutId: 0
        }
      ]
      for (let i = 0; i < titleOptions.length; i++) {
        for (let j = 0; j < titleOptions[i].elementOptions.length; j++) {
          let position = ["top", "bottom", "left", "right"]
          let data = {
            type: titleOptions[i].elementOptions[j].type,
            position: position[i],
            directionIndex: i,
            elementInLayoutId: titleOptions[i].elementOptions[j].elementInLayoutId
          }
          switch (titleOptions[i].elementOptions[j].type) {
            // case "title":
            //   arr[0] = data
            //   break
            // case "subTitle":
            //   arr[1] = data
            //   break
            case "classification":
              arr[0] = data
              break
            case "pagination":
              arr[1] = data
              break
            // case "more":
            //   arr[3] = data
            //   break
            default:
          }
        }
      }
      return arr
    },
    disableSetColAndRow() {
      return this.hasProperty(this.options, "disableSetColAndRow")
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    imgSrc: {
      get() {
        return this.options.imgSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderTypeFlag: {
      get() {
        return this.options.borderTypeFlag || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.borderBottomLeftRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle || "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options ? this.options.borderColor : "#F8F5F5"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (this.options.borderWidth) {
            showBorder = true
          } else {
            showBorder = false
          }
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderShadowChecked: {
      get() {
        return this.boxShadowColor !== "rgba(0, 0, 0,0.5)"
      },
      set(val) {
        if (val) {
          this.boxShadowColor = "#ffffff"
        } else {
          this.boxShadowColor = "rgba(0, 0, 0,0.5)"
        }
      }
    },
    boxShadowColor: {
      get() {
        return this.options ? this.options.boxShadowColor : "#F8F5F5"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    clipSize: {
      get() {
        return this.options ? this.options.clipSize : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clipSize", false)
      }
    },
    repeatType: {
      get() {
        return this.options ? this.options.repeatType : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "repeatType", false)
      }
    },
    alignType: {
      get() {
        return this.options ? this.options.alignType : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "alignType", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          if (background.length === 1 && background[0].type === "color" && !background[0].color) {
            background[0].color = "rgba(255,255,255,0)"
          }
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor || "rgba(255,255,255,0)"
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("paddingTypeFlag")) {
          if (
            ((this.topNavPaddingTop === this.topNavPaddingRight) === this.topNavPaddingLeft) ===
            this.topNavPaddingBottom
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "paddingTypeFlag", "paddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    pageType() {
      return this.$store.state.states.getDataPageIds.pageType
    },
    contentWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "contentWidth", "contentWidth", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentWidth", false)
      }
    },
    showScorll: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "showScorll", "showScorll", false)
      },
      set(newVal) {
        if (newVal === false) {
          this.$changeOptionsEV([100, newVal], ["contentWidth", "showScorll"], false)
        } else {
          this.$changeOptionsEV([false, newVal], ["turnOnScroll", "showScorll"], false)
        }
      }
    },
    scorllType: {
      get() {
        return this.options.hasOwnProperty("scorllType") ? this.options.scorllType : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "scorllType", false)
      }
    },
    isLoginEngine() {
      return this.options && this.options.pluginName && this.options.pluginName[0] == "loginEngineComponentPlugin"
    },
    isSearchComponent() {
      return (
        this.options &&
        (this.options.pluginName?.includes("searchComponentPlugin") || this.options.menuName === "列表页搜索")
      )
    },
    topHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[0], "height", "height", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 0,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "height", false, false, completeParam)
      }
    },
    // 登录组件
    isLoginLayout() {
      return this.options && this.options.pluginName && this.options.pluginName[0] == "loginLayoutComponent"
    },
    // 是否裁剪内容
    showCropping: {
      get() {
        return this.options.hasOwnProperty("showCropping") ? this.options.showCropping : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showCropping", false)
      }
    },
    getTranslate() {
      if (this.scorllType === "vertical") {
        this.translate = 94
      }
      return {
        transform: `translateX(${this.translate}px)`
      }
    },
    overFlowType: {
      get() {
        return this.options.hasOwnProperty("overFlowType") ? this.options.overFlowType : "auto"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "overFlowType", false)
      }
    },
  },
  methods: {
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case 1:
          this.explainTitle = ""
          this.explainTips = "通过调整行数或列数，来对数据排列和数量进行调整"
          this.explainImgSrc = ""
          this.explainVideoSrc = require("../../../assets/images/tipsVideoImg/pailie-video.mp4")
          break
        case 2:
          this.explainTitle = "仅在预览页生效"
          this.explainTips = "勾选裁剪内容后，任何溢出容器的内容都将被隐藏，不会显示在容器的边界之外。"
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/cropping-img.png")
          this.explainVideoSrc = ""
          break
        case 3:
          this.explainTitle = ""
          this.explainTips =
            "开启滚动后，可以选择横向滚动或者竖向滚动，滚动内容宽度必须大于滚动区宽度，才能实现滚动效果。"
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/open-scroll.png")
          this.explainVideoSrc = ""
          break
        default:
      }
    },
    checkShowTabs(name) {
      if (typeof this.showLayoutSetting === "boolean") return this.showLayoutSetting
      return !!this.showLayoutSetting.find(it => it === name)
    },
    initDisplaySetting() {
      this.displayPositionDataModel?.forEach((item, index) => {
        return this.options.titleOptions.some((item1, index1) => {
          return item1.elementOptions.some((item2, index2) => {
            if (item2.type == item.type) {
              item.position = item1.type
              item.elementInLayoutId = item2.elementInLayoutId
              item.directionIndex =
                item.position == "top" ? 0 : item.position == "bottom" ? 1 : item.position == "left" ? 2 : 3
              return true
            }
          })
        })
      })
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    stop(time) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, time)
      })
    },
    changeRowAndColHandle(e) {
      const params = {
        ...this.ids,
        row: e.row,
        col: e.col
      }
      this.$store.dispatch(this.request_prefix + "/changeDataGridLayout", params)
    }
  }
})
</script>

<style scoped lang="scss">
.signal_tb {
  max-width: 100%;
  width: 328px;
  height: 62px;
}
.signal_tb .item1 {
  width: 100%;
  height: 24px;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_tb .item2 {
  width: 100%;
  height: 38px;
  background: rgba(61, 130, 242, 0.1);
}
.signal_bt {
  max-width: 100%;
  width: 328px;
  height: 62px;
}
.signal_bt .item1 {
  width: 100%;
  height: 38px;
  background: rgba(61, 130, 242, 0.1);
}
.signal_bt .item2 {
  width: 100%;
  height: 24px;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_lr {
  max-width: 100%;
  width: 328px;
  height: 62px;
  clear: both;
}
.signal_lr .item1 {
  width: 24px;
  height: 62px;
  float: left;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.signal_lr .item2 {
  width: calc(100% - 24px);
  height: 62px;
  float: left;
  background: rgba(61, 130, 242, 0.1);
}
.signal_rl {
  max-width: 100%;
  width: 328px;
  height: 62px;
  clear: both;
}
.signal_rl .item1 {
  width: calc(100% - 24px);
  height: 62px;
  background: rgba(61, 130, 242, 0.1);
  float: left;
}
.signal_rl .item2 {
  width: 24px;
  height: 62px;
  float: left;
  border: 1px dashed rgba(61, 130, 242, 0.8);
}
.keep-all {
  word-break: keep-all;
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: var(--themeColor);
  padding: 8px 68px;
}
.childPageSettingBtn:hover {
  cursor: pointer;
}
.mr32 {
  margin-right: 32px;
}
.btn-wrapper {
  background-color: var(--inputBg);
  border-radius: 4px;
  padding: 6px 0;
  font-size: 0;
  margin-left: 16px;
  .num-btn {
    display: inline-block;
    width: 38px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    cursor: pointer;
    &:not(:last-child) {
      border-right: 1px solid var(--sliderBackGround);
    }
    &:not(.disabled):hover {
      color: var(--themeColor);
    }
    &.disabled {
      color: var(--borderColorSeven);
      cursor: not-allowed;
    }
  }
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
  margin-top: 0;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.third-text {
  color: var(--thirdTextColor);
}
.font-arrangement-btn .btn-active {
  width: calc((100% - 6px) / 2);
}
.font-arrangement-btn.height32 span {
  height: 26px;
  line-height: 26px;
  font-size: 13px;
}
</style>
